export const productItem = {
  id: 1,
  title: "Nike Zoom KD 12",
  caption: "Tênis de corrida masculino",
  description: "Kevin Durant sempre pareceu relaxado até a hora do ataque. Seu jogo é reservado, mas explosivo, difícil de defender e impossível de parar. O KD12 foi feito para seu domínio e energia infinitas durante todo o jogo com a mais recente inovação na tecnologia Nike Zoom Air.", 
  price: 749.90,
  variations: [
    { slug: 'red', urlPhoto: './nike-zoom-red.png', colorCode: '#F84848' },
    { slug: 'black', urlPhoto: './nike-zoom-black.png', colorCode: '#444444' },
    { slug: 'green', urlPhoto: './nike-zoom-green.png', colorCode: '#29B864' },
    { slug: 'blue', urlPhoto: './nike-zoom-blue.png', colorCode: '#2175F5' },
    { slug: 'orange', urlPhoto: './nike-zoom-orange.png', colorCode: '#FF5521' },
  ],
  sizes: [37,38,39,40,41,42,43,44,45]
}